<div class="relative grid grid-cols-1 gap-8 mt-8">

    <div *ngIf="video" class="top-0 w-full row-span-full">
        <div class="flex justify-between">

            <div class="flex-none">
                <button [routerLink]="['..']"
                    class="text-primary-500 hover:bg-primary-100 text-sm uppercase font-bold px-4 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
                    type="button"><i class="fa fa-chevron-left mr-2 leading-relaxed"></i>
                    Back
                </button>
            </div>

            <div class="md:hidden justify-end justify-items-end">
                <button [disabled]="working" (click)="toggleDropdown($event)" #btnDropdownRef
                    class="min-w-10 w-10 h-10 bg-gray-300 active:bg-primary-500 text-primary-500 active:text-white hover:bg-primary-300 hover:text-white disabled:bg-primary-200 px-4 py-2 rounded-full shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
                    type="button"><i class="fas fa-ellipsis-vertical"></i>
                </button>
                <div class="min-w-48 z-50" #popoverDropdownRef>
                    <div
                        class="bg-white text-base z-50 py-2 list-none text-left rounded shadow-lg mt-1 min-w-48 {{ dropdownPopoverShow ? 'block' : 'hidden'}}">

                        <a [routerLink]="['edit']" class="cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                        text-blueGray-700">
                            <i class="fa fa-edit mr-2 leading-relaxed"></i>Edit
                        </a>
                        <a (click)="refreshRecord()" class="cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                        text-blueGray-700">
                            <i class="fa fa-refresh mr-2 leading-relaxed"></i>Refresh
                        </a>
                        <a (click)="deleteVideo()" class="cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                        text-red-500">
                            <i class="fa fa-trash-can mr-2 leading-relaxed"></i>Delete
                        </a>
                        <a *ngIf="video.publishStatus == 'review'" (click)="publishVideo()" class="cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                        text-secondary-500">
                            <i class="far fa-check-circle mr-2 leading-relaxed"></i>Publish
                        </a>
                    </div>
                </div>
            </div>

            <div class="hidden md:block">
                <button (click)="deleteVideo()" [disabled]="working"
                    class="bg-red-500 text-white active:bg-red-500 hover:bg-red-300 disabled:bg-primary-200 text-sm uppercase font-bold px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-3 ease-linear transition-all duration-150"
                    type="button"><i class="fa fa-trash-can mr-2 leading-relaxed"></i>
                    Delete
                </button>

                <button [routerLink]="['edit']" [disabled]="working"
                    class="bg-primary-400 active:bg-primary-500 hover:bg-primary-700 disabled:bg-primary-200 text-white hover:shadow-lg shadow text-sm font-bold uppercase px-4 py-2 rounded outline-none focus:outline-none mr-3 ease-linear transition-all duration-150"
                    type="button"><i class="fa fa-edit mr-2 leading-relaxed"></i>Edit
                </button>

                <button (click)="refreshRecord()" [disabled]="working"
                    class="bg-primary-400 text-white active:bg-primary-500 hover:bg-primary-700 disabled:bg-primary-200 text-sm uppercase font-bold px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none {{video.publishStatus == 'review' ? 'mr-3' : ''}}  ease-linear transition-all duration-150"
                    type="button"><i class="fa fa-refresh mr-2 leading-relaxed"></i>
                    Refresh
                </button>

                <button *ngIf="video.publishStatus == 'review'" (click)="publishVideo()" [disabled]="working"
                    class="bg-secondary-500 text-white active:bg-primary-500 hover:bg-secondary-700 disabled:bg-primary-200 text-sm uppercase font-bold px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                    type="button"><i class="far fa-check-circle mr-2 leading-relaxed"></i>
                    Publish
                </button>
            </div>
        </div>
    </div>

    <div *ngIf="video"
        class="relative flex flex-col break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">

        <div class="rounded-t bg-white mb-0 px-6 py-4">
            <div class="text-center flex justify-between items-center">
                <span class="text-blueGray-700 text-lg font-bold">{{video.title}}</span>
            </div>
        </div>

        <div class="flex flex-wrap p-6">
            <div class="w-full lg:w-12/12 mb-8">
                <div class="w-full">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Video
                    </label>
                    <video *ngIf="video.link" controls class="center h-56">
                        <source [src]="video.link" />
                    </video>
                    <!-- <video *ngIf="video.link" id="my-video" class="video-js" controls preload="auto" width="640"
                            height="264" poster="MY_VIDEO_POSTER.jpg" data-setup="{}">
                            <source [src]="video.link" type="video/mp4" />
                            <p class="vjs-no-js">
                                To view this video please enable JavaScript, and consider upgrading to a
                                web browser that
                                <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5
                                    video</a>
                            </p>
                        </video> -->
                    <!-- <span>{{video.link}}</span> -->
                </div>
            </div>
            <div class="w-full lg:w-12/12 mb-8">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                    Preview Image
                </label>
                <div class="flex flex-row w-full h-32">
                    <div class="rounded mr-4">
                        <img *ngIf="video.imageUrl" [src]="video.imageUrl" class="bg-white rounded h-32" />
                    </div>
                    <!-- <div class="rounded">
                            <uppy-dashboard [uppy]="uppy" [props]="dashboardProps"></uppy-dashboard>
                            <span class="text-xs text-primary-300 mt-2">Image files only, up to 5 Mb</span>
                        </div> -->
                    <div>
                        <uppy-dashboard-modal [uppy]="uppy" [open]="showModal"
                            [props]="dashboardModalProps"></uppy-dashboard-modal>
                        <button type="button" (click)="showModal = !showModal"
                            class="rounded h-32 w-48 bg-primary-100 border-2 border-dashed border-primary-200">
                            <span class="text-sm text-primary-500">{{ showModal ? 'Close Upload Window' : 'Upload
                                New Image' }}</span>
                            <span class="text-xs text-primary-300 inline-block">Only Images below 5 Mb</span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="w-full lg:w-12/12 mb-8">
                <div class="w-full">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Publish Status
                    </label>
                    <span class="text-blueGray-600 capitalize text-sm">{{video.publishStatus}}</span>
                </div>
            </div>
            <div class="w-full lg:w-12/12 mb-8">
                <div class="relative w-full mb-3">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Description
                    </label>
                    <span class="text-blueGray-600 text-sm whitespace-pre-line">{{video.description}}</span>
                </div>
            </div>
            <div class="w-full mb-8">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                    Tags
                </label>
                <div class="flex flex-wrap gap-1">
                    <span *ngFor="let item of video?.tags; index as i" data-dismissible="chip"
                        class="relative flex select-none items-center whitespace-nowrap rounded-lg bg-primary-600 py-1.5 px-3 text-xs font-bold text-white">
                        {{item}}
                    </span>
                </div>
            </div>
            <div class="w-full lg:w-12/12 mb-8">
                <div class="relative w-full">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Language
                    </label>
                    <span class="text-blueGray-600 capitalize text-sm">{{video.lang}}</span>
                </div>
            </div>
        </div>
    </div>
</div>